import type { PricerSolarStatus } from '../types/pricer-solar.types';

/** El estado de una cotización solar, en palabras (la lista y la ficha dicen lo mismo). */
export const ETIQUETA_DE_ESTADO: Record<PricerSolarStatus, string> = {
  DRAFT: 'Borrador',
  PENDING_APPROVAL: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  ADJUSTMENT_REQUESTED: 'En ajuste',
  CANCELLED: 'Cancelada',
};

/**
 * El color del estado (variantes de `Badge`). El borrador va en gris: la píldora azul sólida de antes
 * gritaba más que los datos en una tabla llena de borradores.
 */
export const VARIANTE_DE_ESTADO: Record<
  PricerSolarStatus,
  'default' | 'warning' | 'success' | 'destructive' | 'secondary' | 'info' | 'outline'
> = {
  DRAFT: 'secondary',
  PENDING_APPROVAL: 'warning',
  APPROVED: 'success',
  REJECTED: 'destructive',
  ADJUSTMENT_REQUESTED: 'warning',
  CANCELLED: 'outline',
};
